import { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";
import { toDMY, toISO } from "@/lib/dates";

// Typed DD/MM/YYYY box. Value in/out is ISO yyyy-mm-dd. A calendar icon opens the native picker.
export const DateInput = ({ value, onChange, className = "", inputClassName = "", ...rest }) => {
  const [text, setText] = useState(toDMY(value));
  const picker = useRef(null);

  useEffect(() => {
    setText(toDMY(value));
  }, [value]);

  const commit = (raw) => {
    const iso = toISO(raw);
    if (iso) {
      onChange(iso);
      setText(toDMY(iso));
    } else if (!String(raw).replace(/\D/g, "")) {
      onChange("");
      setText("");
    } else {
      setText(toDMY(value));
    }
  };

  return (
    <span className={`relative inline-flex items-center ${className}`}>
      <input
        {...rest}
        type="text"
        inputMode="numeric"
        placeholder="DD/MM/YYYY"
        maxLength={10}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={(e) => commit(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit(e.currentTarget.value);
        }}
        className={`w-full pr-6 ${inputClassName}`}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label="Pick a date"
        onClick={() => (picker.current?.showPicker ? picker.current.showPicker() : picker.current?.click())}
        className="absolute right-1 text-zinc-400 hover:text-[var(--mod-primary)]"
      >
        <CalendarDays size={13} />
      </button>
      <input
        ref={picker}
        type="date"
        tabIndex={-1}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="pointer-events-none absolute right-1 h-0 w-0 opacity-0"
      />
    </span>
  );
};
